var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "#475168"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0571 57H41.0224V51.9942C46.1155 50.767 49.2558 47.2461 49.2558 42.5709C49.2558 37.7854 46.7027 34.8548 40.7185 32.7703C38.5218 31.9746 35.9818 30.9323 35.9818 29.9984C35.9818 28.7712 37.7133 28.5825 38.7431 28.5825C41.754 28.5825 43.6806 29.5053 44.8343 30.0563L46.1587 30.6876L46.5789 29.2979L48.2297 23.1172L47.3124 22.6857C46.0911 22.1142 44.1383 21.3988 41.255 21.1541V17H34.2897V21.6472C29.4536 22.8987 26.4727 26.3075 26.4727 30.7829C26.4727 36.5527 31.3633 38.9286 35.6254 40.3593C39.2459 41.5753 39.7468 42.4532 39.7468 43.2171C39.7468 44.3528 38.1035 44.8608 36.4752 44.8608C33.303 44.8608 30.6654 43.6841 29.3804 42.9818L28.0072 42.2346L26 50.0404V50.0423L26.8235 50.4943C28.6807 51.5179 31.4195 52.2388 34.0571 52.4761V57Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2558,
    height: 40,
    fill: "white",
    transform: "translate(26 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon6);
export default __webpack_public_path__ + "static/media/about-icon6.b7f1afdd69e68c939d1ed67b7ec90c1f.svg";
export { ForwardRef as ReactComponent };